import { authApi } from './authService';
import type {
  AuditLogEntry,
  AuditLogFilters,
} from '@/types/members';

const BASE = '/audit-logs';

export const auditLogService = {
  async list(
    filters: AuditLogFilters = {},
  ): Promise<{ data: AuditLogEntry[]; pagination: { page: number; pageSize: number; total: number } }> {
    const params: Record<string, string | number> = {};

    if (filters.page) params.page = filters.page;
    if (filters.pageSize) params.pageSize = filters.pageSize;
    if (filters.event_type) params.event_type = filters.event_type;
    if (filters.user_id) params.user_id = filters.user_id;
    if (filters.owner_id) params.owner_id = filters.owner_id;
    if (filters.email) params.email = filters.email;

    const response = await authApi.get(BASE, { params });
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    };
  },

  async getById(id: string): Promise<AuditLogEntry> {
    const response = await authApi.get(`${BASE}/${id}`);
    return response.data.data;
  },

  async searchByEmail(
    email: string,
    page = 1,
    pageSize = 25,
  ): Promise<{ data: AuditLogEntry[]; pagination: { page: number; pageSize: number; total: number } }> {
    return this.list({ email, page, pageSize });
  },

  async searchByEventType(
    eventType: AuditLogFilters['event_type'],
    page = 1,
    pageSize = 25,
  ): Promise<{ data: AuditLogEntry[]; pagination: { page: number; pageSize: number; total: number } }> {
    return this.list({ event_type: eventType, page, pageSize });
  },
};
